import { notFound } from 'next/navigation';
import { API } from '../api';
import { axiosInstance } from '../axios';
import { CatalogFilterStateParams, ICatalogFilterStateData } from './types';

export const getCatalogFilterState = async (body: CatalogFilterStateParams | null) => {
  try {
    const result = await axiosInstance.post<ICatalogFilterStateData>(API.postCatalogFilterState, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return result.data.data;
  } catch (e: any) {
    if (e.response) {
      const statusCode = e.response.status;

      if (statusCode === 404) {
        return notFound();
      } else {
        console.error(`Server error here: ${statusCode}`, e);
        return { error: true, exception: e };
      }
    }

    return { error: true, exception: e };
  }
};
